import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { accountService } from '@/api/services/account';
import { head } from '@/router/Head';

const listReceivedAccountInvitesQuery = accountService.listReceivedAccountInvitesQuery();

export const Route = createFileRoute('/_authenticated/_dashboard/invitations')({
  beforeLoad: () => ({ listReceivedAccountInvitesQuery }),
  staticData: {
    title: 'Invitations',
    domain: 'account',
  },
  loader: ({ context }) => context.queryClient.prefetchQuery(context.listReceivedAccountInvitesQuery),
  head,
  component: lazyRouteComponent(() => import('./invitations.component'), 'InvitationsComponent'),
  pendingComponent: lazyRouteComponent(() => import('./invitations.component'), 'InvitationsPendingComponent'),
});
